export enum UploadEntity {
  Organisation = 'organisation',
  Forecast = 'forecast',
  Driver = 'driver'
}
